import React, { useEffect, useState } from 'react';

import {
  Chat,
  Container,
  Content,
  Social,
} from '../../styles/pages/help/styles';
import Header from '../../components/Header';
import Head from 'next/head';
import MobileMenu from '../../components/MobileMenu';
import { useRouter } from 'next/router';
import Button from '../../components/UI/Button';
import { CircularProgress } from '@mui/material';

declare global {
  interface Window {
    zE?: (
      id: string,
      command: string,
      callback?: (() => void) | string
    ) => void;
    googletag?: any;
  }
}

const Help: React.FC & { layout: string } = () => {
  const [isLoadingButton, setIsLoadingButton] = useState(true);
  const [width, setWidth] = useState(0);
  const [isHidden, setIsHidden] = useState(true);
  const router = useRouter();

  useEffect(() => {
    setTimeout(() => {
      window?.zE('webWidget', 'setLocale', 'pt-br');
      if (document.body.clientWidth <= 770) {
        window?.zE('webWidget', 'hide');
      } else {
        window?.zE('webWidget', 'open');
      }

      window?.zE('webWidget:on', 'close', function () {
        if (document.body.clientWidth <= 770) {
          window?.zE('webWidget', 'hide');
        }
      });

      window?.zE('webWidget:on', 'open', function () {
        window?.zE('webWidget', 'show');
      });

      setIsLoadingButton(false);
    }, 1000);

    return () => {
      window?.zE('webWidget', 'hide');
      setIsHidden(true);
    };
  }, [router.pathname]);

  useEffect(() => {
    if (!isHidden && width <= 770) {
      window?.zE('webWidget', 'hide');
      setIsHidden(true);
    }

    if (isHidden && width > 770) {
      window?.zE('webWidget', 'open');
      setIsHidden(false);
    }

    function handleResize() {
      setWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [width]);

  return (
    <>
      <Head>
      <script 
          id="ze-snippet" 
          src="https://static.zdassets.com/ekr/snippet.js?key=cb635852-55fa-4ba2-ae71-d3473e44e6c2"
          ></script>        
      </Head>
      <Header />
      <Container>
        <div className="backgroundHeader" />
        <div className="banner">
          <div className="text">
            <h1>
              Tem alguma dúvida? Você pode encontrar a resposta em nossa <br />
              <a
                href=" https://cointimes.zendesk.com/hc/pt-br"
                target="_blank"
                rel="noopener noreferrer"
              >
                Central de Ajuda.
              </a>
            </h1>
          </div>
        </div>
      </Container>
      <Chat>
        <div>
          <Button
            className="chat-button"
            dark
            onClick={() => window.zE('webWidget', 'open')}
            disabled={isLoadingButton}
          >
            {isLoadingButton ? (
              <CircularProgress size={50} className="loading" />
            ) : (
              <>
                <h2>Chat Online</h2>
                <span>Precisa de uma ajuda agora?</span>
              </>
            )}
          </Button>
        </div>
      </Chat>
      <Content>
        <div className="box">
          <h2>Email</h2>
          <span>
            Quer entrar em contato conosco? Podemos te ajudar pelo nosso canal
            de e-mail.
          </span>
          <a
            href="https://coingoback.zendesk.com/hc/pt-br/requests/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Fale com a gente!
          </a>
        </div>
        <div className="box">
          <h2>Avalie a sua experiência</h2>
          <span>
            Estamos sempre escutando as avalições dos nossos clientes, por isso
            é tão importante que você deixe sua resposta!
          </span>
          <a
            href="https://forms.gle/ARJRGV8TL4o3w6rh8 "
            target="_blank"
            rel="noopener noreferrer"
          >
            Avalie
          </a>
        </div>
        <div className="box">
          <h2>Construa Conosco</h2>
          <span>
            Deixe a sua sugestão de melhorias para nossa plataforma! Você faz
            parte de toda essa construção e queremos te ouvir! 😃
          </span>
          <a
            href="https://forms.gle/EzZW7BCz3txVFgRa6"
            target="_blank"
            rel="noopener noreferrer"
          >
            Clique e ajude
          </a>
        </div>
      </Content>
      <Social>
        <h1>Siga o @Cointimes</h1>
        <span>
          Estamos ativos pelas nossas redes sociais abaixo, fique ligado nas
          novidades!
        </span>
        <div>
          <a
            href="https://www.instagram.com/cointimes"
            target="_blank"
            rel="noopener noreferrer"
          >
            instagram
          </a>
          <a
            href="https://www.facebook.com/cointimesnews"
            target="_blank"
            rel="noopener noreferrer"
          >
            facebook
          </a>
          <a
            href="https://twitter.com/CointimesNews"
            target="_blank"
            rel="noopener noreferrer"
          >
            twitter
          </a>
          <a
            href="https://www.linkedin.com/company/cointimes"
            target="_blank"
            rel="noopener noreferrer"
          >
            linkedin
          </a>
        </div>
      </Social>
      <MobileMenu />
    </>
  );
};

Help.layout = 'login';
export default Help;
